import * as React from 'react';

import { ITgbNativedescGeneralProps, TgbNativedescGeneral } from './TgbNativedescGeneral';
import { TgbNativedescGeneralContext } from '../../../../../types/AdfoxBannerContexts';

/**
 * @description Размеры desktop-карточки TGB. У нас нет AdfoxContext с getCompleteSizes (как в исходнике),
 * поэтому задаём фиксированные размеры напрямую. height нужен number для MortgageAnnotations.
 */
const SIZES = { width: '100%', height: 376 };

interface ITgbNativedescGeneralContainerProps {
  context: TgbNativedescGeneralContext;
}

export const TgbNativedescGeneralContainer: React.FC<ITgbNativedescGeneralContainerProps> = ({ context }) => {
  const {
    annotation,
    image,
    url,
    metroDistance,
    metroColor,
    metro,
    description,
    title,
    location,
    button,
    label,
    logoImageUrl,
    builderName,
    mortgageTermsWarning,
    mortgageWarning,
  } = context;

  const transports: ITgbNativedescGeneralProps['transports'] = [];

  if (metro) {
    /**
     * @description iconType недоступен — нашему беку не приходит serverData.additionalParams.undergroundIconType.
     * Поэтому иконка метро не отрисуется, отобразится только текст станции.
     */
    transports.push({
      iconColor: metroColor,
      iconType: undefined,
      id: 1,
      name: metro,
      remoteness: metroDistance,
    });
  }

  const tgbNativedescGeneralProps: ITgbNativedescGeneralProps = {
    logoImageUrl,
    url,
    transports,
    label,
    button,
    image,
    annotation,
    builderName,
    title,
    address: location,
    description,
    sizes: SIZES,
    mortgageTermsWarning,
    mortgageWarning,
  };

  return <TgbNativedescGeneral {...tgbNativedescGeneralProps} />;
};

TgbNativedescGeneralContainer.displayName = 'TgbNativedescGeneralContainer';
